import { Component, EventEmitter, Output } from "@angular/core";

/**
 * Base class for form components (regardless of it being shipping or account) 
 * that need field focus tracking functionality.
 * Provides shared implementation of onFieldFocus method to avoid duplication.
 */
@Component({
  selector: 'form-base',
  template: ''
})
export abstract class FormBaseComponent {
  @Output() fieldFocused = new EventEmitter<string>();
  protected firstFieldFocused: boolean = false;

  constructor() {
    // Base constructor - derived classes must call super()
  }

  /**
   * Handles field focus events and emits the first field focused event.
   * Only emits once per component instance.
   * @param fieldName - The name of the field that received focus
   */
  onFieldFocus(fieldName: string): void {
    if (!this.firstFieldFocused) {
      this.firstFieldFocused = true;
      this.fieldFocused.emit(fieldName);
    }
  }
}

